import { createReducer } from '@reduxjs/toolkit';
import _ from 'lodash';
import { TYPES } from '../../common/constants';

const setFormLoaderLoadingDone = () => {
    return true
};

const stopFormLoaderLoadingDone = () => {
    return false
}




const initialState = false;

export default createReducer(initialState, {
  [TYPES.SET_FORMLOADER_LOADING]: setFormLoaderLoadingDone,
  [TYPES.STOP_FORMLOADER_LOADING]: stopFormLoaderLoadingDone,
});
